import { useContext } from "react";

import { Text } from "@magnetic/text";

import { withShowToggle } from "src/components/hoc/withShowToggle";
import { TimeZoneContext } from "src/core/timeZoneProvider";
import { getUTCTimeZoneAbbreviation } from "src/utils/timeZone/timeZoneUtils";

interface DateColumnHeaderProps {
  readonly label: React.ReactNode;
}
export const DateColumnHeader = withShowToggle(
  ({ label }: DateColumnHeaderProps) => {
    const { timeZone } = useContext(TimeZoneContext);
    return (
      <div data-qa="date-column-header">
        {label}
        <Text size="p4" weight="semi-bold" color="light">
          {getUTCTimeZoneAbbreviation(timeZone, { withParentheses: true })}
        </Text>
      </div>
    );
  }
);
